const getOpenid = function () {
    console.warn('正在引用当前环境不支持的api === getOpenid ===');
};
const userInit = function () {
    console.warn('正在引用当前环境不支持的api === userInit ===');
};
const queryReportStatus = function () {
    console.warn('正在引用当前环境不支持的api === queryReportStatus ===');
};
const reportUserInfo = function () {
    console.warn('正在引用当前环境不支持的api === reportUserInfo ===');
};
const subscribeInit = function () {
    console.warn('正在引用当前环境不支持的api === subscribeInit ===');
};
const tryToSubscribe = function () {
    console.warn('正在引用当前环境不支持的api === tryToSubscribe ===');
};
const getAlwaysSubscribeStatus = function () {
    console.warn('正在引用当前环境不支持的api === getAlwaysSubscribeStatus ===');
};
const getCommonSubscribeStatus = function () {
    console.warn('正在引用当前环境不支持的api === getCommonSubscribeStatus ===');
};
const tryToCommonSubscribe = function () {
    console.warn('正在引用当前环境不支持的api === tryToCommonSubscribe ===');
};
const buildWithShareParams = function () {
    console.warn('正在引用当前环境不支持的api === buildWithShareParams ===');
};
const dchnBatchProcess = function () {
    console.warn('正在引用当前环境不支持的api === dchnBatchProcess ===');
};
export { getOpenid, userInit, queryReportStatus, reportUserInfo, subscribeInit, tryToSubscribe, getAlwaysSubscribeStatus, buildWithShareParams, dchnBatchProcess, getCommonSubscribeStatus, tryToCommonSubscribe };
